import { render, staticRenderFns } from "./AboutUsIcons.vue?vue&type=template&id=4e280d4e&scoped=true"
var script = {}
import style0 from "./AboutUsIcons.vue?vue&type=style&index=0&id=4e280d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e280d4e",
  null
  
)

export default component.exports